module.exports = __webpack_public_path__ + "img/flover-yellow.776eaa3.png";